import { render, staticRenderFns } from "./TableDesigner.vue?vue&type=template&id=67ad5760&scoped=true&"
import script from "./TableDesigner.vue?vue&type=script&lang=js&"
export * from "./TableDesigner.vue?vue&type=script&lang=js&"
import style0 from "./TableDesigner.vue?vue&type=style&index=0&id=67ad5760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad5760",
  null
  
)

export default component.exports